import { render, staticRenderFns } from "./MSquare.vue?vue&type=template&id=79d9a9f0&scoped=true"
import script from "./MSquare.vue?vue&type=script&lang=js"
export * from "./MSquare.vue?vue&type=script&lang=js"
import style0 from "./MSquare.vue?vue&type=style&index=0&id=79d9a9f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d9a9f0",
  null
  
)

export default component.exports